import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Image from 'react-image'
import hasDom from 'utils/hasDom'
import Modalhandler from 'components/shared/modal/modal-handler'
import GalleryModal from 'components/shared/modals/venue-gallery'
import GalleryLoader from 'components/shared/loaders/gallery'
import ResizeImage from 'utils/resizeImage'
import NoImage from 'assets/images/no-image.jpg'
import ceil from 'lodash/ceil'
import dropRight from 'lodash/dropRight'

const SpaceGridGallery = ({ images, title, address, heightFixed }) => {
  const [imageSize, setImageSize] = useState({})
  const isImagesLessThanThree = images.length < 3
  const isImagesOnePhotoOnly = images.length <= 1

  useEffect(() => {
    if (hasDom) {
      const screenWidth = window.innerWidth
      const mainSize =
        screenWidth > 640 && !isImagesOnePhotoOnly ? ceil((screenWidth / 3) * 2) : screenWidth
      const otherSize = screenWidth > 640 ? ceil(screenWidth / 3) : screenWidth
      setImageSize({ mainSize, otherSize })
    }
  }, [])
  return (
    <div id="gallery" className="gallery relative w-full">
      {!isImagesOnePhotoOnly && (
        <span className="m-6 right-0 top-0 absolute">
          <Modalhandler
            className="btn rounded font-normal lato px-5 py-3 bg-secondary-lightgray text-primary-black"
            title="View Photos"
          >
            {({ toggle }) => (
              <GalleryModal
                images={images.map((img) => ({
                  ...img,
                  src: ResizeImage(img?.src, { w: window?.innerWidth }),
                }))}
                toggle={toggle}
                title={title}
                address={address}
              />
            )}
          </Modalhandler>
        </span>
      )}
      {imageSize.mainSize && (
        <div
          className={`grid ${isImagesLessThanThree && 'override'} ${
            isImagesOnePhotoOnly && 'single'
          }`}
        >
          {dropRight(images, images.length - 3).map((image, key) => (
            <div
              className={`${
                isImagesLessThanThree ? 'image-container' : 'image-container-multiple'
              }`}
              key={key}
            >
              <Image
                src={[
                  `${
                    key === 0
                      ? ResizeImage(image?.src, { w: imageSize.mainSize })
                      : ResizeImage(image?.src, { w: imageSize.otherSize })
                  }`,
                  NoImage,
                ]}
                alt={image.alt}
                loader={<GalleryLoader className={key === 0 ? 'primary' : ''} />}
                style={{ height: heightFixed ?? '' }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

SpaceGridGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  address: PropTypes.string,
  heightFixed: PropTypes.string,
}

export default SpaceGridGallery
